<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">
                {{ assunto.id ? "Editar Assunto" : "Novo Assunto" }}
              </h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Nome <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="assunto.nome"
                      id="nomeAssunto"
                      placeholder="Nome do assunto"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Descrição</label>
                    <textarea
                      class="form-control"
                      v-model="assunto.descricao"
                      rows="3"
                      placeholder="Descrição opcional do assunto"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/assuntos" class="btn btn-back mr-1">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add" @click="save">
            Salvar <i class="fa fa-save"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      assunto: {
        nome: "",
        descricao: "",
      },
    };
  },
  methods: {
    save() {
      const self = this;
      let api = self.$store.state.api + "assuntos";

      self.$loading(true);

      if (self.assunto.id) {
        api += "/" + self.assunto.id;
        self.assunto._method = "PUT";
      }

      axios
        .post(api, self.assunto)
        .then(() => {
          self.$message("Sucesso", "Assunto salvo com sucesso", "success");
          self.$loading(false);
          self.$router.push("/assuntos");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getAssunto(id) {
      const self = this;
      const api = self.$store.state.api + "assuntos/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.assunto = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.getAssunto(id);
    } else {
      this.$nextTick(() => {
        document.getElementById("nomeAssunto").focus();
      });
    }
  },
};
</script>
